import { css, createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  *,
  *::after,
  *::before {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: inherit;
  }
  html {
    font-size: 10px;
    font-family: 'Inter', sans-serif;
    overflow-x: hidden;
    scroll-behavior: smooth;

    ${window.location.port !== "6006" && css`
      background: ${(props) => props.theme.colors.background};
      ${(props) => props.theme.mixins.hideScroll};
    `}
  }
  button {
    background: transparent;
    border: none;
    outline: none;
    cursor: pointer;
  }
  input {
    background: transparent;
    border: none;
    outline: none;
  }
  a {
    text-decoration: none;
  }
  .hiddenAnimation {
    opacity: 0;
  }
`;